import { Component, Input, Output } from '@angular/core';
import { AppClientConfigurationService } from '@sdbn/common';
import { Station } from '../../../../../../client/model/station';
import { TransportDetailsLayoutConverter } from '../../../../../../common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailLayout, TransportDetailMode } from '../../../../../../common/configuration/transport.configuration';
import { LayoutDefinition } from '../../../../../../components/transport-details/transport-details-model';

@Component({
    selector: 'app-sac-mobile-transport-details',
    templateUrl: './transport-details.component.html',
    styleUrls: ['./transport-details.component.scss'],
    standalone: false
})
export class MobileSacTransportDetailsComponent {

  TransportDetailMode = TransportDetailMode;

  @Input() station: Station;

  layoutDefinition: TransportDetailLayout;

  constructor(
    private configurationService: AppClientConfigurationService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter
  ) {
    this.layoutDefinition = transportDetailsLayoutConverter.convert(this.readLayout());
  }

  private readLayout(): LayoutDefinition {
    // TODO eigenen Key für mobile Client bauen
    const propertyKey = 'ui-component.station-assignment.transport-details-grid.layout';
    const param = this.configurationService.getProperty(propertyKey);

    if (param != null && param.value != null && param.value.length > 0) {
      try {
        const layout = new LayoutDefinition(JSON.parse(param.value));
        layout.dictionaryBase = 'dd.PROPERTY';
        // TODO im neuen Ansatz gibt es keine ID mehr, Lösung offen
        // layout.propertyId = param.id;
        return layout;
      } catch (error) {
        console.error('Error while reading layout form config [' + propertyKey + '].');
        return null;
      }
    }
  }

}
